/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Segment } from 'semantic-ui-react';
import { FormControlLabel, Checkbox } from '@mui/material';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { changeBrowserTabTitle } from '../slices/browserTabTitle/browserTabTitleSlice';
import { globalLoadingOff, globalLoadingOn } from "../slices/globalLoading/globalLoadingSlice";
import { userLoggedIn, selectCurrentUserIdToken, selectDisplayTheTermsOfAgreement, selectCurrentUserTermsOfUseAccepted, selectCurrentUserDataPersonalAgreementAccepted } from '../slices/currentUser/currentUserSlice';
import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';
import '../App.css';

const fevir_go_server_address = server_config["fevir_go_server_address"];

//const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

const agreedToTermsAction = async (idToken, previousUrlState, setPreviousUrlState, navigate, dispatch) => {
    if (idToken) {
        dispatch(globalLoadingOn());
        const body = {
            'functionid': "login",
            'idToken': idToken,
            'agreetoterms': true
        };
        await axiosInstance({
            method: 'POST',
            url: fevir_go_server_address,
            timeout: 8000,
            data: body,
        }).then(async (resp) => {
            dispatch(globalLoadingOff());
            if (resp?.data?.success) {
                const loadedData = resp.data;
                const fevirUserPayload = {
                    userId: loadedData.id,
                    name: loadedData.name,
                    userPublicDetail: {
                        shortbio: loadedData.shortbio,
                        affiliations: loadedData.affiliations
                    },
                    userPrivateDetail: {
                        displaythetermsofagreement: loadedData.displaythetermsofagreement,
                        termsofuseaccept: loadedData.termsofuseaccept,
                        datapersonalagreementaccept: loadedData.datapersonalagreementaccept,
                        email: loadedData.email,
                        notificationemail: loadedData.notificationemail,
                        additionalemail: loadedData.additionalemail,
                        status: loadedData.status,
                        admin: loadedData.admin,
                        idToken: idToken,
                        apiToken: loadedData.apiToken,
                        favoritefois: loadedData.favoritefois,
                        notificationfois: loadedData.notificationfois,
                        numberunreadnotifications: loadedData.numberunreadnotifications,
                        numberunclearednotifications: loadedData.numberunclearednotifications
                    }
                }
                dispatch(userLoggedIn(fevirUserPayload)); //Not needed since the page will just reload
                //await delay(250); //A hacky solution to wait a quarter of a second, since this function is infrequently called.
                if (previousUrlState) {
                    let previousUrl = previousUrlState;
                    setPreviousUrlState(null);
                    window.location.replace(previousUrl);
                } else {
                    window.location.replace("/editprofile");
                }
            } else {
                navigate(0);
            }
        }).catch((e) => {
            console.log(e);
            dispatch(globalLoadingOff());
        });
    }
}

const TermsOfAgreementPage = ({ waitingForVerificationEmail, previousUrlState, setPreviousUrlState }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const idToken = useSelector(selectCurrentUserIdToken);
    const displayTheTermsOfAgreement = useSelector(selectDisplayTheTermsOfAgreement);
    const termsOfUseAccepted = useSelector(selectCurrentUserTermsOfUseAccepted);
    const dataPersonalAgreementAccepted = useSelector(selectCurrentUserDataPersonalAgreementAccepted);

    const [agreementState, setAgreementState] = useState({
        termsofuseacceptCheckbox: false,
        datapersonalagreementacceptCheckbox: false
    });

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR Terms of Agreement"));
    }, []);

    useEffect(() => {
        setAgreementState(prevState => {
            return { ...prevState, "termsofuseacceptCheckbox": termsOfUseAccepted?.slice(-1) >= "2026-04-30" };
        });
    }, [termsOfUseAccepted]);

    useEffect(() => {
        setAgreementState(prevState => {
            return { ...prevState, "datapersonalagreementacceptCheckbox": dataPersonalAgreementAccepted?.slice(-1) >= "2025-09-09" };
        });
    }, [dataPersonalAgreementAccepted]);

    useEffect(() => {
        if (!displayTheTermsOfAgreement) {
            if (previousUrlState) {
                navigate(previousUrlState, { replace: true });
                setPreviousUrlState(null);
            } else {
                navigate("/editprofile");
            }
        }
    }, [displayTheTermsOfAgreement]);

    return <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
        {(firebase.auth().currentUser?.emailVerified === false || waitingForVerificationEmail) ?
            <h2>Please verify your email. Check your spam folder. (If you already did verify please refresh the page.)</h2>
            :
            <div>
                <h2 style={{ textAlign: "center", color: "#AC3B61" }}>{selectCurrentUserDataPersonalAgreementAccepted.length && "Updated"} Terms of Agreement</h2>
                {/*<Button style={{ position: "absolute", right: "3px", top: "3px" }}
                        className="formButton negative" content="✖"
                        onClick={() => { navigate("/"); }} />
                    <br /><br />*/}
                {selectCurrentUserDataPersonalAgreementAccepted.length > 0 &&
                    <div>
                        <p>The Terms of Use (Acceptable Use Policy) was updated on April 30, 2026 to clarify that the Content is copyright Computable Publishing LLC if not otherwise stated within the Content (or the copyright owner stated within the content is not capable of owning a copyright), and to specify license terms for noncommercial use and for commercial use.</p>
                    </div>}
                <FormControlLabel
                    control={<Checkbox style={{ pointerEvents: "auto" }} name="termsofuseaccept"
                        inputProps={{ 'aria-label': 'Agree to the Terms of Use' }} color="primary"
                        checked={agreementState.termsofuseacceptCheckbox}
                        onChange={(e) => {
                            setAgreementState(prevState => {
                                return { ...prevState, "termsofuseacceptCheckbox": e.target.checked };
                            });
                        }} />}
                    label={<span>I agree to the <a href="/termsofuse" target="_blank"
                        rel="noopener noreferrer"
                        style={{ pointerEvents: "auto" }}>Acceptable Use Policy</a></span>}
                />
                <br />
                <FormControlLabel
                    style={{ pointerEvents: "none" }}
                    control={<Checkbox style={{ pointerEvents: "auto" }} name="datapersonalagreementaccept"
                        inputProps={{ 'aria-label': 'Agree to the Personal Data Agreement Terms' }}
                        color="primary" checked={agreementState.datapersonalagreementacceptCheckbox}
                        onChange={(e) => {
                            setAgreementState(prevState => {
                                return { ...prevState, "datapersonalagreementacceptCheckbox": e.target.checked };
                            });
                        }} />}
                    label={<span>I agree to the <a href="/personaldataagreement" target="_blank"
                        rel="noopener noreferrer"
                        style={{ pointerEvents: "auto" }}>Privacy Policy Agreement</a></span>}
                />
                <br /><br />
                {idToken &&
                    <Button className="formButton positive"
                        content="Agree to the Terms" compact
                        onClick={() => { agreedToTermsAction(idToken, previousUrlState, setPreviousUrlState, navigate, dispatch); }}
                        disabled={!(agreementState.termsofuseacceptCheckbox &&
                            agreementState.datapersonalagreementacceptCheckbox)} />
                }
            </div>
        }
    </Segment>;
};

export default TermsOfAgreementPage;